import { Subject } from 'rxjs';
import { GameServices } from '../../services/game-services';
import { TwentyOne } from 'game-logic';
import { TwentyOneAssetType, TwentyOneStylesType } from '../../model/twentyone-types';

export class LoadingColumnViewModel {
  public get scoreBoxAsset() {
    return this.gameServices.assetCatalogueService.getAsset(TwentyOneAssetType.ScoreBox);
  }
  public get labelColor() {
    return this.gameServices.gameThemeService.getHexColor(TwentyOneStylesType.ScoreLabelFill);
  }
  public get defaultFontFamily() {
    return this.gameServices.gameThemeService.defaultFontFamily;
  }
  public get layoutConfig() {
    return this.gameServices.gameMetricsService.gameLayoutConfig;
  }
  public get onGameSetupStart$() {
    return this.gameServices.twentyOneGameRunner.onGameSetupStart$;
  }
  public get onResetGameScene$() {
    return this.onResetGameScene;
  }
  public get columnIndex() {
    const i = this.columnId as number;
    return i <= 2 ? i - 3 : i - 3;
  }

  private readonly onResetGameScene = new Subject<void>();

  constructor(
    private gameServices: GameServices,
    public readonly columnId: TwentyOne.PileId,
  ) {}

  public resetGameScene(): void {
    this.onResetGameScene.next();
  }
}
